// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mobile_titleWrapper__n2NTY {
  height: 60px;
  border-bottom: 1px solid var(--mui-palette-grey-400);
}

.mobile_title__ERrAZ {
  font-size: 14px;
  font-weight: 600;
}

.mobile_wrapper__oIwkK {
  background: var(--mui-palette-grey-50);
  position: fixed;
  width: 100%;
  z-index: 1;
}

.mobile_wrapperPlaceholderWithBreadcrumbs__DqIrq {
  height: 113px;
}

.mobile_wrapperPlaceholderWithoutBreadcrumbs__1CiP8 {
  height: 64px;
}

.mobile_menuIcon__IzqPI {
  border-radius: 8px;
  padding: 12px;
  background: var(--mui-palette-primary-200)
}
`, "",{"version":3,"sources":["webpack://./src/components/common/header/mobile.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,oDAAoD;AACtD;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb;AACF","sourcesContent":[".titleWrapper {\n  height: 60px;\n  border-bottom: 1px solid var(--mui-palette-grey-400);\n}\n\n.title {\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.wrapper {\n  background: var(--mui-palette-grey-50);\n  position: fixed;\n  width: 100%;\n  z-index: 1;\n}\n\n.wrapperPlaceholderWithBreadcrumbs {\n  height: 113px;\n}\n\n.wrapperPlaceholderWithoutBreadcrumbs {\n  height: 64px;\n}\n\n.menuIcon {\n  border-radius: 8px;\n  padding: 12px;\n  background: var(--mui-palette-primary-200)\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"titleWrapper": `mobile_titleWrapper__n2NTY`,
	"title": `mobile_title__ERrAZ`,
	"wrapper": `mobile_wrapper__oIwkK`,
	"wrapperPlaceholderWithBreadcrumbs": `mobile_wrapperPlaceholderWithBreadcrumbs__DqIrq`,
	"wrapperPlaceholderWithoutBreadcrumbs": `mobile_wrapperPlaceholderWithoutBreadcrumbs__1CiP8`,
	"menuIcon": `mobile_menuIcon__IzqPI`
};
export default ___CSS_LOADER_EXPORT___;
